.wrapper {
  padding: 3em;
  max-width: 1000px;
  margin: 0 auto;
}
